"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("es6-symbol/implement"); //ponyfills Symbol for IE. Observe uses Symbol
const observe_1 = __importDefault(require("observe"));
const pako_1 = __importDefault(require("pako"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const defaultMessages_1 = require("../constants/defaultMessages");
if (!window_or_global_1.default._epicGamesFooterObserverCallbacks) {
    window_or_global_1.default._epicGamesFooterObserverCallbacks = [];
}
if (!window_or_global_1.default._epicGamesFooter) {
    window_or_global_1.default._epicGamesFooter = {};
}
if (typeof window_or_global_1.default._epicGamesFooter === "string" && /^([0-9]+),/.test(window_or_global_1.default._epicGamesFooter)) {
    // EpicGamesNav is pako encoded.
    try {
        const preload = JSON.parse(pako_1.default.inflate(window_or_global_1.default._epicGamesFooter.split(","), { to: "string" }));
        window_or_global_1.default._epicGamesFooter = preload;
        //allow the root._epicGamesFooter.messages to override the constants
    }
    catch (error) {
        // Ignore.
        window_or_global_1.default._epicGamesFooter = {};
    }
}
if (window_or_global_1.default._epicGamesFooter && window_or_global_1.default._epicGamesFooter.messages) {
    for (const message in defaultMessages_1.defaultMessages) {
        if (window_or_global_1.default._epicGamesFooter.messages[message]) {
            defaultMessages_1.defaultMessages[message] = window_or_global_1.default._epicGamesFooter.messages[message];
        }
    }
}
/**
 * Set the defaults for the config.
 */
const defaultConfig = {
    //sets the app links
    links: [],
    //sets the social links
    socialLinks: [],
    //sets the logos to use
    logos: ["eg", "ue"],
    legalTags: [],
    copyrights: [
        "© {YEAR}, Epic Games, Inc. Epic Games, Paragon, Unreal, Unreal Engine 4, UE4, and their respective logos are trademarks or registered trademarks of Epic Games, Inc. in the United States of America and elsewhere. All rights reserved.", //eslint-disable-line max-len
    ],
    callToAction: {},
};
//Loop over the epicGamesNav object and plug in any missing keys from the defaultConfig
if (!window_or_global_1.default._epicGamesFooter) {
    window_or_global_1.default._epicGamesFooter = defaultConfig;
}
else {
    if (typeof window_or_global_1.default._epicGamesFooter === "string") {
        console.log("root._epicGamesFooter is string");
    }
    for (const key in defaultConfig) {
        if (key && typeof key === "string") {
            if (!Object.hasOwnProperty.call(window_or_global_1.default._epicGamesFooter, key)) {
                window_or_global_1.default._epicGamesFooter[key] = defaultConfig[key];
            }
        }
    }
}
window_or_global_1.default._epicGamesFooterObserver = (0, observe_1.default)(window_or_global_1.default._epicGamesFooter);
window_or_global_1.default._epicGamesFooterObserver.on("change", (change) => {
    if (window_or_global_1.default._epicGamesFooterObserverCallbacks && window_or_global_1.default._epicGamesFooterObserverCallbacks.length) {
        for (let i = 0; i < window_or_global_1.default._epicGamesFooterObserverCallbacks.length; i += 1) {
            const callback = window_or_global_1.default._epicGamesFooterObserverCallbacks[i];
            if (callback && typeof callback === "function") {
                callback(change);
            }
        }
    }
});
window_or_global_1.default._epicGamesFooterObserverCreated = true;
const addObserverCallback = (fn) => {
    if (typeof fn === "function") {
        window_or_global_1.default._epicGamesFooterObserverCallbacks.push(fn);
    }
};
exports.default = addObserverCallback;
//# sourceMappingURL=epicGamesFooterObserver.js.map